<template>
  <div>
    <h5 class="text-center info-text">Complete la información del seguimiento de Emergencia</h5>

    <div class="row mt-5">
      <div class="col-sm-6 mb-4">
        <div class="form-group">
          <label>Plantas por Metro</label>

          <el-input v-model="formData.plantsPerMeter" name="plantsPerMeter" placeholder="Plantas por metro"> </el-input>

          <small v-show="plantsPerMeter.invalid" class="text-danger">
            {{ getError('plantsPerMeter') }}
          </small>
        </div>
      </div>

      <div class="col-sm-12 mb-2">
        <div class="form-group">
          <label>Densidad de Plantas:&nbsp;</label>
          <label v-if="plot.groovesDistance" class="text-lg font-weight-bolder">
            {{ formData.plantsPerMeter | plantsDensity(plot.groovesDistance) }}
          </label>
          <span v-else class="text-danger d-block small">
            Debe cargar la distancia entre surcos del lote para poder realizar el calculo de semillas por hectárea
          </span>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="form-group">
          <label for>Fertilización</label>
          <el-checkbox
            v-model="formData.hasNitrogenFertilization"
            border
            class="form-control"
            label="Fertilización Nitrogenada"
            name="hasNitrogenFertilization"
          >
          </el-checkbox>

          <el-select
            v-if="formData.hasNitrogenFertilization"
            v-model="formData.nitrogenFertilization"
            v-validate="modelValidations.nitrogenFertilization"
            autocomplete="off"
            filterable
            name="nitrogenFertilization"
            placeholder="Estadío (*)"
          >
            <el-option label="V4" value="V4"></el-option>
            <el-option label="V6" value="V6"></el-option>
            <el-option label="V8" value="V8"></el-option>
            <el-option label="V10" value="V10"></el-option>
          </el-select>

          <small v-show="nitrogenFertilization.invalid" class="text-danger">
            {{ getError('nitrogenFertilization') }}
          </small>

          <el-input
            v-if="formData.hasNitrogenFertilization"
            v-model="formData.fertilizationDosis"
            v-validate="modelValidations.fertilizationDosis"
            autocomplete="off"
            name="fertilizationDosis"
            placeholder="Dosis [Kg/HA]"
            class="mt-2"
          >
          </el-input>

          <small v-show="fertilizationDosis.invalid" class="text-danger">
            {{ getError('fertilizationDosis') }}
          </small>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <label class="mt-3">Controles</label>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-sm-6 mb-4">
        <el-checkbox
          v-model="formData.hasPestControl"
          border
          class="form-control"
          label="Control de Plagas"
          name="hasPestControl"
        >
        </el-checkbox>

        <el-input
          v-if="formData.hasPestControl"
          v-model="formData.pestControl"
          v-validate="modelValidations.pestControl"
          name="pestControl"
          placeholder="Producto y dosis (*)"
        >
        </el-input>

        <small v-show="pestControl.invalid" class="text-danger">
          {{ getError('pestControl') }}
        </small>
      </div>

      <div class="col-sm-6 mb-4">
        <el-checkbox
          v-model="formData.hasWeedControl"
          border
          class="form-control"
          label="Control de Malezas"
          name="hasWeedControl"
        >
        </el-checkbox>

        <el-input
          v-if="formData.hasWeedControl"
          v-model="formData.weedControl"
          v-validate="modelValidations.weedControl"
          name="weedControl"
          placeholder="Producto y dosis (*)"
        >
        </el-input>

        <small v-show="weedControl.invalid" class="text-danger">
          {{ getError('weedControl') }}
        </small>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="form-group mt-3">
          <label class="control-label">Precipitaciones</label>

          <el-select
            v-model="formData.rainfall"
            v-validate="modelValidations.rainfall"
            autocomplete="off"
            filterable
            name="rainfall"
            placeholder="Cultivo (*)"
          >
            <el-option label="Nulas (0 a 200mm)" value="Nulas"></el-option>
            <el-option label="Escasas (200 a 500mm)" value="Escasas"></el-option>
            <el-option label="Normales (500 a 600mm)" value="Normales"></el-option>
            <el-option label="Abundantes (+600mm)" value="Abundantes"></el-option>
          </el-select>

          <small v-show="rainfall.invalid" class="text-danger">
            {{ getError('rainfall') }}
          </small>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="form-group">
          <label class="control-label mt-3">Temperaturas promedio</label>

          <el-select
            v-model="formData.averageTemperature"
            v-validate="modelValidations.averageTemperature"
            autocomplete="off"
            filterable
            name="averageTemperature"
            placeholder="Cultivo (*)"
          >
            <el-option label="Bajas" value="Bajas"></el-option>
            <el-option label="Medias" selected value="Medias"></el-option>
            <el-option label="Altas" value="Altas"></el-option>
          </el-select>

          <small v-show="averageTemperature.invalid" class="text-danger">
            {{ getError('averageTemperature') }}
          </small>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12 col-md-4">
        <el-checkbox v-model="formData.hailStorms" border class="form-control" label="Granizo" name="hailStorms">
        </el-checkbox>
      </div>

      <div class="col-sm-12 col-md-4">
        <el-checkbox
          v-model="formData.heatStrokes"
          border
          class="form-control"
          label="Golpes de Calor"
          name="heatStrokes"
        >
        </el-checkbox>
      </div>

      <div class="col-sm-12 col-md-4">
        <el-checkbox v-model="formData.frost" border class="form-control" label="Heladas" name="frost"> </el-checkbox>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <label class="mt-3">Enfermedades</label>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <el-checkbox v-model="formData.tizon" border class="form-control" label="Tizón" name="tizon"> </el-checkbox>
      </div>

      <div class="col-sm-6">
        <el-checkbox
          v-model="formData.helminthosporium"
          border
          class="form-control"
          label="Helminthosporium"
          name="helminthosporium"
        >
        </el-checkbox>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <el-checkbox v-model="formData.roya" border class="form-control" label="Roya" name="roya"> </el-checkbox>
      </div>

      <div class="col-sm-6">
        <el-checkbox v-model="formData.cornStreak" border class="form-control" label="Rayado Fino" name="cornStreak">
        </el-checkbox>
      </div>
    </div>

    <button class="btn btn-success btn-fill btn-wd btn-next float-right" @click="save">Guardar</button>
  </div>
</template>

<script>
import { mapFields } from 'vee-validate';
import { Select, Option, DatePicker, Checkbox } from 'element-ui';

export default {
  components: {
    [Checkbox.name]: Checkbox,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
  },

  props: {
    plot: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      formData: {
        plantsDensity: this.plot.emergence ? this.plot.emergence.plantsDensity : null,
        plantsPerMeter: this.plot.emergence ? this.plot.emergence.plantsPerMeter : null,
        hasNitrogenFertilization: this.plot.emergence ? Boolean(this.plot.emergence.nitrogenFertilization) : false,
        nitrogenFertilization: this.plot.emergence ? this.plot.emergence.nitrogenFertilization : null,
        fertilizationDosis: this.plot.emergence ? this.plot.emergence.fertilizationDosis : null,
        hasWeedControl: this.plot.emergence ? Boolean(this.plot.emergence.weedControl) : false,
        weedControl: this.plot.emergence ? this.plot.emergence.weedControl : null,
        hasPestControl: this.plot.emergence ? Boolean(this.plot.emergence.pestControl) : false,
        pestControl: this.plot.emergence ? this.plot.emergence.pestControl : null,
        hailStorms: this.plot.emergence ? Boolean(this.plot.emergence.hailStorms) : false,
        rainfall: this.plot.emergence ? this.plot.emergence.rainfall : 'Nulas',
        averageTemperature: this.plot.emergence ? this.plot.emergence.averageTemperature : 'Bajas',
        heatStrokes: this.plot.emergence ? Boolean(this.plot.emergence.heatStrokes) : false,
        frost: this.plot.emergence ? Boolean(this.plot.emergence.frost) : false,
        tizon: this.plot.emergence ? Boolean(this.plot.emergence.tizon) : false,
        helminthosporium: this.plot.emergence ? Boolean(this.plot.emergence.helminthosporium) : false,
        roya: this.plot.emergence ? Boolean(this.plot.emergence.roya) : false,
        cornStreak: this.plot.emergence ? Boolean(this.plot.emergence.cornStreak) : false,
        plotId: this.plot.id,
      },

      modelValidations: {
        nitrogenFertilization: {
          required: true,
        },

        fertilizationDosis: {
          required: true,
        },

        weedControl: {
          required: true,
        },

        pestControl: {
          required: true,
        },
      },
    };
  },

  computed: {
    ...mapFields([
      'plantsDensity',
      'plantsPerMeter',
      'nitrogenFertilization',
      'fertilizationDosis',
      'weedControl',
      'pestControl',
      'hailStorms',
      'rainfall',
      'averageTemperature',
      'heatStrokes',
      'frost',
      'tizon',
      'helminthosporium',
      'roya',
      'cornStreak',
    ]),
  },

  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },

    async validate() {
      try {
        return await this.$validator.validateAll();
      } catch (e) {
        return new Promise((resolve, reject) => {
          reject(e);
        });
      } finally {
      }
    },

    save() {
      this.validate().then((res) => {
        if (res) {
          this.store();
        }
      });
    },

    async store() {
      this.formData.plotId = this.plot.id;
      const response = (await this.plot.emergence) ? this.update() : this.create();

      response.then((res) => res.data.data).then((data) => this.$emit('saved', data));
    },

    create() {
      return this.$services.resource('emergences').create(this.formData);
    },

    update() {
      return this.$services.resource('emergences').update(this.plot.emergence.id, this.formData);
    },
  },
};
</script>

<style scoped>
.form-group .el-date-editor--date {
  width: 100%;
}
</style>
